import type { ReactNode } from "react";

export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function hasRenderableDialogContent(content: ReactNode | null | undefined) {
  return content !== null && content !== undefined && typeof content !== "boolean";
}
